import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { urlUpload } from '../../common';

@Injectable({
  providedIn: 'root'
})
export class UploadfileService {

  constructor(private http: HttpClient) { }

  uploadFile(formData: FormData){
    return this.http.post(urlUpload, formData);
  }

  uploadFileImgPubs(formData: FormData){// imagenes de portadas de publicaciones
    return this.http.post(`/api/v1/img-pubs`, formData);
  }

  uploadFileRepo(formData: FormData) {//servicio para subir pdfs en carperta reportes
    return this.http.post(`/api/v1/pdf-reportes`, formData);
  }

  deletedFileRepo(unicode: string) {//servicio para elimninar pdfs en carperta reportes
    return this.http.delete(`/api/v1/del-pdf-reporte/${unicode}`);
  }

  uploadFileRepoSec(formData: FormData) {//servicio para subir pdfs en carperta reportes/sectorial
    return this.http.post(`/api/v1/pdf-reportes-sctl`, formData);
  }

  deletedFileRepoSec(unicode: string) {//servicio para elimninar pdfs en carperta reportes/sectorial
    return this.http.delete(`/api/v1/del-pdf-reporte-sctl/${unicode}`);
  }

  uploadFileImgPNI(formData: FormData) {//servicio para subir imagenes carpeta podcast nextEpisodes
    return this.http.post(`/api/v1/img-nexp`, formData);
  }

  uploadFilePubs(formData: FormData) {//servicio para subir pdfs en carperta  publicaciones
    return this.http.post(`/api/v1/pdf-pubs`, formData);
  }

  deletedFilePubs(unicode: string) {//servicio para elimninar pdfs en carperta reportes
    return this.http.delete(`/api/v1/del-pubs/${unicode}`);
  }

  uploadFileLisMet(formData: FormData) {//servicio para subir pdfs en carperta  listado_metodologico
    return this.http.post(`/api/v1/pdf-lm`, formData);
  }

  deletedFileMet(unicode: string) {//servicio para elimninar pdfs en carperta reportes
    return this.http.delete(`/api/v1/del-pdf-lm/${unicode}`);
  }

  uploadFileImgF(formData: FormData) {//servicio para subir imagen de portada de foro
    return this.http.post(`/api/v1/img-f`, formData);
  }

  uploadFileImgFC(formData: FormData) {//servicio para subir imagen de carousel para foro
    return this.http.post(`/api/v1/img-fc`, formData);
  }

  uploadFilePDFF(formData: FormData) {//servicio para subir pdfs relacionados a un foro
    return this.http.post(`/api/v1/pdf-f`, formData);
  }

  deletedFileForo(unicode: string) {//servicio para elimninar pdfs en carperta pdf foros
    return this.http.delete(`/api/v1/del-pdf-foro/${unicode}`);
  }

  uploadFileIMGR(formData: FormData) {//servicio para subir pdfs relacionados a un foro
    return this.http.post(`/api/v1/img-r`, formData);
  }

  uploadBase64Image(base64: string, filename: string) {
    const body = { base64String: base64, filename };
    return this.http.post('/api/v1/upload-base64-image', body); // Servicio para manejar archivos en base64
  }

  uploadFilePDFEncuentro(formData: FormData) {//servicio para subir pdfs relacionados a un encuentro
    return this.http.post(`/api/v1/pdf-encuentro`, formData);
  }

  deletedFileEncuentro(unicode: string) {//servicio para elimninar pdfs en carperta pdf encuentros
    return this.http.delete(`/api/v1/del-pdf-encuentro/${unicode}`);
  }

}
